<template>
  <v-card class="mx-2 mb-10" max-width="515" flat outlined>
    <v-img
      class="white--text align-end"
      height="100px"
      gradient="to top right, rgba(30, 30, 30, 0.58), rgba(30, 30, 30, 0.58)"
      src="https://static.mmmint.ai/wirkaufendeinethg/thg-overview-invite-friends.jpeg"
    >
      <v-card-title>{{ $t("components.thg.ThgInviteFriendsCard.title") }}</v-card-title>
    </v-img>
    <v-card-text v-if="myAffiliate.note">
      {{ myAffiliate.note }}
    </v-card-text>
    <v-list>
      <v-list-item v-for="item in items" :key="item.title" :three-line="isRenderingThreeLines">
        <v-list-item-icon>
          <v-icon :color="partnerColorDarkmode">
            {{ item.icon }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
          <v-list-item-subtitle>{{ item.subtitle }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-card-text>
      {{ $t("components.thg.ThgInviteFriendsCard.registeredCars") }}
      <v-tooltip max-width="250px" right>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
        </template>
        <span>{{ $t("components.thg.ThgInviteFriendsCard.info") }}</span> </v-tooltip
      ><br />
      <span class="text-h4 font-weight-bold" :style="`color:${partnerColorDarkmode}`">{{ myAffiliate.timesUsed }}</span>
    </v-card-text>
    <span v-if="myAffiliate.isValid">
      <v-card-actions class="mx-2">
        <v-btn block :color="partnerColorDarkmode" dark @click="copyLinkToClipboard(myAffiliate.code)">
          {{ $t("components.thg.ThgInviteFriendsCard.btnText") }}
        </v-btn>
      </v-card-actions>
      <v-card-subtitle class="text-caption">
        {{ $t("components.thg.ThgInviteFriendsCard.termsOfUse") }}
      </v-card-subtitle>
    </span>
    <span v-else>
      <v-card-subtitle class="text-caption">
        {{ $t("components.thg.ThgInviteFriendsCard.invalidCode") }}
      </v-card-subtitle>
    </span>
  </v-card>
</template>

<style scoped></style>

<script lang="ts">
import CreateOrUpdateBankDialog from "@/components/profile/CreateOrUpdateBankDialog.vue";
import EditProfileDialog from "@/components/profile/EditProfileDialog.vue";
import { AffiliateTypeEnum } from "@/lib/enum/AffiliateType.enum";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { ThgShortAffiliateViewmodelGen } from "@/services/thg/v1/data-contracts";
import { ReportModule } from "@/store/modules/report.store";
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: { CreateOrUpdateBankDialog, EditProfileDialog }
})
export default class ThgInviteFriendsCard extends Vue {
  @Prop()
  myAffiliate!: ThgShortAffiliateViewmodelGen;

  get isRenderingThreeLines() {
    return this.$vuetify.breakpoint.name === "xs";
  }

  get items() {
    if (this.myAffiliate.type === AffiliateTypeEnum.FREINDS) {
      return this.itemsFriends;
    }
    return this.itemsAlt;
  }

  get itemsFriends() {
    return [
      {
        icon: "mdi-checkbox-marked-circle-outline",
        title: this.$t("components.thg.ThgInviteFriendsCard.explainationTitle1"),
        subtitle: this.$t("components.thg.ThgInviteFriendsCard.explainationText1")
      },
      {
        icon: "mdi-checkbox-marked-circle-outline",
        title: this.$t("components.thg.ThgInviteFriendsCard.explainationTitle2"),
        subtitle: this.$t("components.thg.ThgInviteFriendsCard.explainationText2")
      },
      {
        icon: "mdi-checkbox-marked-circle-outline",
        title: this.$t("components.thg.ThgInviteFriendsCard.explainationTitle3"),
        subtitle: this.$t("components.thg.ThgInviteFriendsCard.explainationText3")
      }
    ];
  }

  get itemsAlt() {
    return [
      {
        icon: "mdi-checkbox-marked-circle-outline",
        title: this.$t("components.thg.ThgInviteFriendsCard.explainationTitleAlt1"),
        subtitle: this.$t("components.thg.ThgInviteFriendsCard.explainationTextAlt1")
      },
      {
        icon: "mdi-checkbox-marked-circle-outline",
        title: this.$t("components.thg.ThgInviteFriendsCard.explainationTitleAlt2"),
        subtitle: this.$t("components.thg.ThgInviteFriendsCard.explainationTextAlt2")
      },
      {
        icon: "mdi-checkbox-marked-circle-outline",
        title: this.$t("components.thg.ThgInviteFriendsCard.explainationTitleAlt3"),
        subtitle: this.$t("components.thg.ThgInviteFriendsCard.explainationTextAlt3")
      }
    ];
  }

  get inviteText() {
    return this.$t("components.thg.ThgInviteFriendsCard.inviteText", {
      prefix: ThgCreateModule.bonusPrefix,
      bonus: ThgCreateModule.bonus
    });
  }

  createAffiliateLink(code: string) {
    return this.inviteText + "https://" + ReportModule.partner.settings?.defaultUrl + "/#/?code=" + code;
  }

  get color() {
    return getDefaultPartnerColor();
  }

  get partnerColorDarkmode() {
    return this.$vuetify.theme.dark ? "white" : this.color;
  }

  copyLinkToClipboard(code: string) {
    navigator.clipboard.writeText(this.createAffiliateLink(code));
    this.$toast.info("In Zwischenablage kopiert.");
  }
}
</script>
